import React from 'react';
import { FaSearchengin } from 'react-icons/fa';
import { HiBell, HiChip, HiCursorClick, HiDeviceTablet } from 'react-icons/hi';

const InfoLogin = () => {
  const textDescription = [
    {
      icon: <HiCursorClick />,
      title: '100 Free Pages of Regulations Every Month',
      text: 'One click access to any page of any regulation',
    },
    {
      icon: <HiChip />,
      title: '10 Free Ai Queries Every Month',
      text: 'Find the insights you need in a secure trusted environment. All sources fully referenced',
    },
    {
      icon: <FaSearchengin />,
      title: 'Personalised Alerts to Change',
      text: 'Instant notification of updates – never miss a new version',
    },
    {
      icon: <HiDeviceTablet />,
      title: 'Access on any device',
      text: 'Mobile and tablet optimised',
    },
  ];

  return (
    <div className='cardCorporate info-text'>
      <h2
        style={{
          fontSize: '31px',
        }}
      >
        <b>With Regulationcity, Enjoy These Benefits Today</b>
      </h2>
      {textDescription.map((item, index) => {
        return (
          <div key={index} className='features'>
            <div className='features__icon'>{item.icon}</div>
            <div>
              <h3
                style={{
                  fontSize: '25px',
                }}
              >
                <b>{item.title}</b>
              </h3>
              <p
                style={{
                  fontSize: '20px',
                }}
              >
                <b>{item.text}</b>
              </p>
            </div>
          </div>
        );
      })}
    </div>
  );
};

export default InfoLogin;
